var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('Wp_news',{attrs:{"datas":_vm.list,"auto-play":_vm.auto_play},on:{"clickItem":_vm.clickNewsItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }